import axios from '@/utils/axios';

export const doLogin = data => axios.post('v1/AccessControl/User/Login', data);
export const getUserInfo = () =>
    axios.get('v1/AppServer/User/GetCurrentUserSimpleInfo');
export const getAllUserComboxList = () =>
    axios.get('/v1/AppServer/User/GetAllUserComboxList');
export const getLoginOption = () => axios.get('/v1/AppServer/User/GetLoginOption');
export const searchUser = params =>
    axios.get('v1/AppServer/User/SearchUser', {params, ignorShowLoading: true});

export const getUserPermissions = () => axios.get('v1/AppServer/User/GetCurrentUserPrivilegeCodes');
export const getCurrentUserSimpleMenus = () => axios.get('v1/AppServer/User/GetCurrentUserSimpleMenus');

export const getMenuTree = () => axios.get('v1/AccessControl/Menu/GetMenuTree');
export const getMenuById = id =>
    axios.get('v1/AppServer/Menu/GetMenuById', {params: {id}});
export const addMenu = params =>
    axios.post('v1/AccessControl/Menu/Add', params);
export const editMenu = params =>
    axios.put('v1/AccessControl/Menu/Edit', params);
export const deleteMenu = data =>
    axios.delete('v1/AccessControl/Menu/delete', {data});
export const getUserPicUrl = id =>
    axios.get('v1/AppServer/User/GetUserPicUrl?id=' + id);

//瑞航通和员工自愿报告地址
export const getHomeConfig = () => axios.get('v1/AppServer/Home/GetHomeConfig');

//组件管理
export const getWidgetInfos = params =>
    axios.get('v1/AppServer/Widget/Query', {params});
export const getWidgetInfo = id =>
    axios.get('v1/AppServer/Widget/Find', {params: {id}});
export const addWidgetInfo = params => axios.post('v1/AppServer/Widget/Add', params);
export const updateWidgetInfo = params =>
    axios.put('v1/AppServer/Widget/Update', params);
export const deleteWidget = data =>
    axios.delete('v1/AppServer/Widget/Deletes', {data});

//首页拖动
export const saveHomeIndexLayouts = params =>
    axios.put('v1/AppServer/UserWidget/Save', params);
export const getHomeIndexLayouts = params =>
    axios.get('v1/AppServer/UserWidget/Get', {params});
export const getHomeIndexWidgets = params =>
    axios.get('v1/AppServer/Widget/Get', {params});

//数据字典
export const getDataDictionaryTree = params =>
    axios.get('v1/AppServer/DataDictionary/QueryTree', {params});
export const createOrUpdateDataDictionary = params =>
    axios.put('v1/AppServer/DataDictionary/CreateOrUpdate', params);
export const deleteDataDictionary = data =>
    axios.delete('v1/AppServer/DataDictionary/Delete', {data});
export const getDataDictionary = id =>
    axios.get('v1/AppServer/DataDictionary/Get', {params: {id}});
export const getDataDictionaryCode = code =>
    axios.get('v1/AppServer/DataDictionary/GetCode', {params: {code}});

//枚举、字典，即其它下拉框的key-value获取
export const getKeyValue = (code, group) =>
    axios.get('/v1/AppServer/KeyValue/Get', {params: {code, group}});

// 配置
export const getConfigInfos = params =>
    axios.get('v1/AppServer/Config/Query', {params});
export const getConfigInfo = id =>
    axios.get('v1/AppServer/Config/Find', {params: {id}});
export const addConfigInfo = params => axios.post('v1/AppServer/Config/Add', params);
export const updateConfigInfo = params =>
    axios.put('v1/AppServer/Config/Update', params);
export const deleteConfigInfo = id =>
    axios.delete('v1/AppServer/Config/Delete', {data: id});
export const getConfigValueByCode = params =>
    axios.get('v1/AppServer/Config/GetConfigValueByCode', {params});


//应用信息管理
export const getAppInfos = params => axios.get('v1/AppServer/App/Query', {params});
export const updateAppInfo = params => axios.put('v1/AppServer/App/Update', params);
export const addAppInfo = params => axios.post('v1/AppServer/App/Add', params);
export const deleteAppInfos = data => axios.delete('v1/AppServer/App/Delete', {data});
export const getAppInfo = id => axios.get('v1/AppServer/App/Find', {params: {id}});
export const uploadLogo = params => axios.post('v1/AppServer/App/UploadAppLogo', params);
export const getAppList = params => axios.get('v1/AppServer/App/GetAppList', {params});

// 应用版本管理
export const getPackages = params => axios.get('v1/AppServer/Package/Query', {params});
export const savePackage = data => axios.post('v1/AppServer/Package/savePackage', data);
export const getPackagePatchs = params => axios.get('v1/AppServer/Package/GetPackagePatchs', {params});
export const deletePackage = data => axios.delete('v1/AppServer/Package/Delete', {data});
export const getPackage = id => axios.get('v1/AppServer/Package/Find', {params: {id}});
export const publishPackage = data => axios.post('v1/AppServer/Package/PublishPackage', data);
export const cancelPublishPackage = data => axios.post('v1/AppServer/Package/CancelPublishPackage', data);
export const getVersionList = params => axios.get('v1/AppServer/Package/GetVersionList', {params});
export const getPackagesByAppCode = code => axios.get('v1/AppServer/Package/GetPackagesByAppCode', {params: {code}});
export const getPackagePublishRule = id => axios.get('v1/AppServer/Package/getPackagePublishRule', {params: {id}});


//事件字典
export const getEventDictionaryTree = params =>
    axios.get('v1/AppServer/Event/Query', {params});
export const createOrUpdateEventDictionary = params =>
    axios.put('v1/AppServer/Event/CreateOrUpdate', params);
export const deleteEventDictionary = data =>
    axios.delete('v1/AppServer/Event/Delete', {data});
export const getEventDictionary = id =>
    axios.get('v1/AppServer/Event/Find', {params: {id}});
export const getEventList = appId => axios.get('v1/AppServer/Event/GetEventList', {params: {appId}});
export const getEventLogInfos = params =>
    axios.get('v1/AppServer/EventLog/Query', {params});

//下载页面
export const getAppLatestPackage = appId => axios.get('v1/AppServer/Package/GetAppLatestPackageForWebDownload', {params: {appId}});
//export const getAppLatestPackage = id => axios.get('v1/AppServer/Package/GetAppLatestPackageForWebDownload', {params: {id}});
//DownLoadPackageFile
//获取当前应用的信息
export const getAppInfoByCode = params => axios.get('v1/AppServer/App/getAppInfoByCode', {params});
//应用奔溃日志查询接口
export const getAppCrashLogQuery = params => axios.get('v1/AppServer/AppCrashLog/Query', {params});
export const getCrashLogDetail = params => axios.get('v1/AppServer/AppCrashLog/GetCrashLogDetail', {params});

//应用设备注册统计查询
export const getAppDeviceInfos = params =>
    axios.get('v1/AppServer/AppDevice/Query', {params});


//应用更新日志查询
export const getDownLoadLogInfos = params => axios.get('v1/AppServer/DownLoadLog/Query', {params});
//用户下载更新统计
export const statisticsUserDownload = params =>
    axios.get('v1/AppServer/DownLoadLog/StatisticsUserDownload', {params});

//设备信息查询
export const getDeviceInfos = params => axios.get('v1/AppServer/Device/Query', {params});

//通用日志查询
export const getAppLogs = params => axios.get('v1/AppServer/AppLog/Query', {params});
//用户活跃统计
export const statisticsUserActivity = params =>
  axios.get('v1/AppServer/ActivityStatistics/Query', {params});
export const getUserActivityData = params =>
    axios.get('v1/AppServer/Home/GetUserActivityData', {params});
export const statisticsUserActivityByType = params =>
  axios.get('v1/AppServer/MonthlyActivityStatistics/Query', {params});
//设备活跃统计
export const getDeviceActivityData = params =>
    axios.get('v1/AppServer/Home/GetDeviceActivityData', {params});

// 建议
export const receiveAdvice = data => axios.post('v1/AppServer/Advice/ReceiveAdvice', data);
